module.exports = __webpack_public_path__ + "static/media/inter_new.e7ab8590.png";